import React from 'react';

import { Switch } from 'components/common/ui';
import { DateRangePicker } from 'components/common/InputFieldV2/DateRangePicker';
import { ToggleButtonGroup } from 'components/common/InputFieldV2/ToggleButtonGroup';
import { FilterDropdown } from './FilterDropdown';
import { Dropdown } from './Dropdown';
import { Autocomplete } from './Autocomplete';
import { MultiSelect } from './MultiSelect';
import { MultiSelectWithActions } from './MultiSelectWithActions';
import { TextField } from './TextField';
import { Date } from './Date';
import { Time } from './Time';
import { FilterMultiSelect } from './FilterMultiSelect';
import { FilterAutocomplete } from './FilterAutocomplete';
import { YesNo } from './YesNo';
import CheckBox from './CheckBox/CheckBox';
import RichTextField from './RichTextField/RichTextField';
import { ColorPicker } from './ColorPicker';
import RadioButton from './RadioButton/RadioButton';
import Select from './Select/Select';
import DateTime from './DateTime/DateTime';
import FilterDateTimeRangePicker from './FilterDateTimeRangePicker/FilterDateTimeRangePicker';
import FilterDateTime from './FilterDateTime/FilterDateTime';

const InputFieldV2 = ({
  name = '',
  value,
  onChange,
  type,
  loading = false,
  styles = {},
  hasSelectAllOption = false,
  onInputChange,
  ...rest
}) => {
  switch (type) {
    case 'number':
    case 'text':
    case 'email':
    case 'tel':
    case 'password':
      return (
        <TextField
          name={name}
          value={value}
          onChange={onChange}
          type={type}
          {...rest}
        />
      );
    case 'richText':
      return (
        <RichTextField
          name={name}
          value={value}
          onChange={onChange}
          type={type}
          {...rest}
        />
      );
    case 'dropdown':
      return (
        <Dropdown
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'autocomplete':
      return (
        <Autocomplete
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          {...rest}
        />
      );
    case 'date':
      return (
        <Date
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'time':
      return (
        <Time
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'dateRangePicker':
      return (
        <DateRangePicker
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'dateTime':
      return (
        <DateTime
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'filterDateTime':
      return (
        <FilterDateTime
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'checkbox':
      return (
        <CheckBox
          name={name}
          styles={styles}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'switch':
      return (
        <Switch
          name={name}
          styles={styles}
          disabled={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'colorPicker':
      return (
        <ColorPicker
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'filterDropdown':
      return (
        <FilterDropdown
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'multiselect':
      return (
        <MultiSelect
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          {...rest}
        />
      );
    case 'multiSelectWithActions':
      return (
        <MultiSelectWithActions
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          {...rest}
        />
      );
    case 'filterMultiselect':
      return (
        <FilterMultiSelect
          hasSelectAllOption={hasSelectAllOption}
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          {...rest}
        />
      );
    case 'filterAutocomplete':
      return (
        <FilterAutocomplete
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          {...rest}
        />
      );
    case 'filterDateTimeRangePicker':
      return (
        <FilterDateTimeRangePicker
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'yesno':
      return (
        <YesNo
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          disabled={rest?.disabled}
        />
      );
    case 'radio':
      return (
        <RadioButton
          name={name}
          styles={styles}
          value={value}
          onChange={onChange}
          disabled={rest?.disabled}
        />
      );
    case 'select':
      return (
        <Select
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    case 'toggleButtonGroup':
      return (
        <ToggleButtonGroup
          name={name}
          styles={styles}
          loading={loading}
          value={value}
          onChange={onChange}
          {...rest}
        />
      );
    default:
      return null;
  }
};

export default InputFieldV2;
